export default "__VITE_ASSET__DT1lBVgx__"